export const TURKISH_CITIES = [
  { value: 'adana', label: 'Adana' },
  { value: 'adiyaman', label: 'Adıyaman' },
  { value: 'afyonkarahisar', label: 'Afyonkarahisar' },
  { value: 'agri', label: 'Ağrı' },
  { value: 'amasya', label: 'Amasya' },
  { value: 'ankara', label: 'Ankara' },
  { value: 'antalya', label: 'Antalya' },
  { value: 'artvin', label: 'Artvin' },
  { value: 'aydin', label: 'Aydın' },
  { value: 'balikesir', label: 'Balıkesir' },
  { value: 'bilecik', label: 'Bilecik' },
  { value: 'bingol', label: 'Bingöl' },
  { value: 'bitlis', label: 'Bitlis' },
  { value: 'bolu', label: 'Bolu' },
  { value: 'burdur', label: 'Burdur' },
  { value: 'bursa', label: 'Bursa' },
  { value: 'canakkale', label: 'Çanakkale' },
  { value: 'cankiri', label: 'Çankırı' },
  { value: 'corum', label: 'Çorum' },
  { value: 'denizli', label: 'Denizli' },
  { value: 'diyarbakir', label: 'Diyarbakır' },
  { value: 'edirne', label: 'Edirne' },
  { value: 'elazig', label: 'Elazığ' },
  { value: 'erzincan', label: 'Erzincan' },
  { value: 'erzurum', label: 'Erzurum' },
  { value: 'eskisehir', label: 'Eskişehir' },
  { value: 'gaziantep', label: 'Gaziantep' },
  { value: 'giresun', label: 'Giresun' },
  { value: 'gumushane', label: 'Gümüşhane' },
  { value: 'hakkari', label: 'Hakkari' },
  { value: 'hatay', label: 'Hatay' },
  { value: 'isparta', label: 'Isparta' },
  { value: 'mersin', label: 'Mersin' },
  { value: 'istanbul', label: 'İstanbul' },
  { value: 'izmir', label: 'İzmir' },
  { value: 'kars', label: 'Kars' },
  { value: 'kastamonu', label: 'Kastamonu' },
  { value: 'kayseri', label: 'Kayseri' },
  { value: 'kirklareli', label: 'Kırklareli' },
  { value: 'kirsehir', label: 'Kırşehir' },
  { value: 'kocaeli', label: 'Kocaeli' },
  { value: 'konya', label: 'Konya' },
  { value: 'kutahya', label: 'Kütahya' },
  { value: 'malatya', label: 'Malatya' },
  { value: 'manisa', label: 'Manisa' },
  { value: 'kahramanmaras', label: 'Kahramanmaraş' },
  { value: 'mardin', label: 'Mardin' },
  { value: 'mugla', label: 'Muğla' },
  { value: 'mus', label: 'Muş' },
  { value: 'nevsehir', label: 'Nevşehir' },
  { value: 'nigde', label: 'Niğde' },
  { value: 'ordu', label: 'Ordu' },
  { value: 'rize', label: 'Rize' },
  { value: 'sakarya', label: 'Sakarya' },
  { value: 'samsun', label: 'Samsun' },
  { value: 'siirt', label: 'Siirt' },
  { value: 'sinop', label: 'Sinop' },
  { value: 'sivas', label: 'Sivas' },
  { value: 'tekirdag', label: 'Tekirdağ' },
  { value: 'tokat', label: 'Tokat' },
  { value: 'trabzon', label: 'Trabzon' },
  { value: 'tunceli', label: 'Tunceli' },
  { value: 'sanliurfa', label: 'Şanlıurfa' },
  { value: 'usak', label: 'Uşak' },
  { value: 'van', label: 'Van' },
  { value: 'yozgat', label: 'Yozgat' },
  { value: 'zonguldak', label: 'Zonguldak' },
  { value: 'aksaray', label: 'Aksaray' },
  { value: 'bayburt', label: 'Bayburt' },
  { value: 'karaman', label: 'Karaman' },
  { value: 'kirikkale', label: 'Kırıkkale' },
  { value: 'batman', label: 'Batman' },
  { value: 'sirnak', label: 'Şırnak' },
  { value: 'bartin', label: 'Bartın' },
  { value: 'ardahan', label: 'Ardahan' },
  { value: 'igdir', label: 'Iğdır' },
  { value: 'yalova', label: 'Yalova' },
  { value: 'karabuk', label: 'Karabük' },
  { value: 'kilis', label: 'Kilis' },
  { value: 'osmaniye', label: 'Osmaniye' },
  { value: 'duzce', label: 'Düzce' },
  { value: 'yurtdisi', label: 'Yurt Dışı' },
];

export const getCityLabel = (value) => {
  const city = TURKISH_CITIES.find(city => city.value === value);
  return city ? city.label : value;
}; 